// material-ui
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import {
  Divider,
  Grid,
  Typography,
  Snackbar,
  TextField,
  Button,
  Alert
} from '@mui/material';


// project imports
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import axios from 'src/utils/axios';
import AlertComponent from 'src/components/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import { confirmAlert } from 'react-confirm-alert';


// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //

const styles = {
  ul: {
    '& .MuiPaginationItem-root': {
      '&.Mui-selected': {
        background: '#FF9800',
        color: 'white',
        borderRadius: '50%',
      },
    },
  },
};

const Transfer = ({ EmployeeNr, OrganizationTypeId, EmployeeType }) => {
  const theme = useTheme();
  const [Organization, setOrganization] = useState('');
  if (EmployeeNr === 0) {
    return (
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12
          }}>
          <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
            <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
            </Typography>
          </Alert>      </Grid>
      </Grid>
    );
  }
  const [Warning, setWarning] = useState(false);
  const [WarningType, setWarningType] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState("");
  const [OrganizationControl, setOrganizationControl] = useState("");
  const [loading, setLoading] = useState(false);


  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  const [DealerGroup, setDealerGroup] = React.useState([]);
  const [selectedDealerGroup, setselectedDealerGroup] = React.useState([]);

  const [DealerCompany, setDealerCompany] = React.useState([]);
  const [selectedDealerCompany, setSelectedDealerCompany] = React.useState([]);

  const [DealerArea, setDealerArea] = React.useState([]);
  const [selectedDealerArea, setSelectedDealerArea] = React.useState([]);
  const SessionUser = getUser();
  const [Dealer, setDealer] = React.useState([]);
  const [selectedDealer, setSelectedDealer] = React.useState([]);

  const [yetki, setYetki] = useState([]);
  const [active, setActive] = useState(0);

  const GetDealerData = () => {
    axios.get(`GetDealerDataTransfer/${0}/${0}/${0}`).then((response) => {
      setDealer(response.data);
    });
  }

  const GetDealerAreaData = (Company) => {
    axios.get(`GetDealerAreaData/${selectedDealerGroup?.Id}/${Company}`).then((response) => {
      setDealerArea(response.data);
    });
  }

  const GetDealerCompanyData = (Group) => {
    axios.get(`GetDealerCompanyData/${Group}`).then((response) => {
      setDealerCompany(response.data);
    });

  }

  const GetDealerGroupData = () => {
    axios.get(`GetDealerGroupData`).then((response) => {
      setDealerGroup(response.data);
    });

  }

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      var Data = response.data;
      var newData = Data.filter((item) => item.BirimKodu !== "0");

      setBolgeAdiKodu(newData);
    });

  }

  const getBirimData = (BirimKodu) => {
    if (BirimKodu === undefined) {
      setBirimData([]);
    } else {
      axios.get(`GetBirimData/${BirimKodu}`).then((response) => {
        setBirimData(response.data);
      });
    }
  }

  const getEmployeeYetki = () => {
    setLoading(true);
    axios.get(`GetEmployeeYetki`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setYetki(response.data);
        } else {
          setYetki([]);
        }
        setLoading(false);
      });

  }


  useEffect(() => {
    setLoading(true);
    setOrganizationControl(OrganizationTypeId);
    axios.get(`GetWorkerInfo/${EmployeeNr}`).then((response) => {
      setOrganization(response.data[0]?.ServiceShopCode + '-' + response.data[0]?.ServiceShop + ' Organizasyonunda Çalışıyorsunuz!...');
      setActive(response.data[0]?.Active);
      setLoading(false);
    });
    getEmployeeYetki();
    setLoading(false);
    getBolgeAdiKoduData();
    GetDealerData();
    setLoading(false);
  }, []);

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };

  const handleTransfer = () => {
    if (active === 1) {
      setresponseMessage('Lütfen transfer işlemlerinizden önce çalışanı pasif durumuna alınız!...');
      setWarning(true);
      setWarningType("warning")
      return;
    }
    if (!SelectedBirim.BirimKodu || !selectedbolgeAdiKodu.BirimKodu) {
      setresponseMessage('Lütfen transfer işlemleriniz için birim kodu seçiniz!...');
      setWarning(true);
      setWarningType("warning")
      return;
    }
    confirmAlert({
      message: `${EmployeeNr} nolu elemanı, çalışan tipi ${EmployeeType} şeklinde transfer ediyorsunuz. Değiştirmek isterseniz çalışan tipi alanından doğru seçimi yapınız!`,
      buttons: [
        {
          label: 'Devam Et',
          onClick: () => handleTransferYes()
        },
        {
          label: 'İptal',
          onClick: () => { return; }
        }
      ]
    });

  }

  const handleTransferYes = () => {
    setLoading(true);

    if (OrganizationControl == 1) {
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      const requestData = {
        EmployeeId: EmployeeNr,
        ServiceShopCode: SelectedBirim.BirimKodu,
        RegisteredUser: "", //Oktadan alınıyor
        RoleId: SessionUser?.ManagementRoleId
      };

      axios.post('/SetApolloEmployeeTransfer', requestData, config)
        .then(response => {
          var data = response.data;
          setresponseMessage(data.ErrorDescription);
          setWarning(true);
          setWarningType(data.ErrorCode === "1000" ? "error" : "success")
        });
    } else {


    }
    setLoading(false);
  }

  return (
    <div>
      {
        loading ?
          <Backdrop sx={styles.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Snackbar
            open={Warning}
            autoHideDuration={10000}
            onClose={WarningClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
          </Snackbar>
          <br />
          <Typography variant="h5" sx={{ mb: 1 }}>
            Tranfer İşlemleri: <b style={{ color: 'red' }}>{Organization}</b>
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: 'red', fontWeight: 'bold' }}>
            Sadece pasif durumunda olan çalışanların tranfer işlemlerini gerçekleştirebilirsiniz!...
          </Typography>
          <Divider sx={{ mb: 2 }} />
              <Grid container spacing={2}>
                  <Grid
                    style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                    size={{
                      xs: 12,
                      sm: 12,
                      lg: 6
                    }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={selectedbolgeAdiKodu}
                      options={bolgeAdiKodu}
                      getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferBolge')?.DISABLE_ALAN}
                      onChange={(event, newValue) => {
                        setSelectedbolgeAdiKodu(newValue);
                        getBirimData(newValue?.BirimKodu);
                        setSelectedBirim([])

                      }}
                      renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}

                    />
                  </Grid>
                  <Grid
                    style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}
                    size={{
                      xs: 12,
                      sm: 12,
                      lg: 6
                    }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={SelectedBirim}
                      options={BirimData}
                      getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferBirim')?.DISABLE_ALAN}
                      onChange={(event, newValue) => {
                        setSelectedBirim(newValue);


                      }}
                      renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}

                    />
                  </Grid>


                  <Grid
                    style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}
                    size={{
                      xs: 12,
                      sm: 12,
                      lg: 12
                    }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={selectedDealer}
                      options={Dealer}
                      getOptionLabel={(option) => { return option.Id ? (option.Id + ' - ' + option.Dsc) : '-' }}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferDealer')?.DISABLE_ALAN}
                      onChange={(event, newValue) => {
                        setSelectedDealer(newValue);


                      }}
                      renderInput={(params) => <TextField {...params} label="Bayi" variant="outlined" />}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      sm: 12,
                      lg: 12
                    }}>
                    <Grid container spacing={1} justifyContent="flex-end">
                      <Grid style={{ textAlign: "right" }} size={12}>
                        <Button
                          variant="contained"
                          color="secondary"
                          startIcon={<TransferWithinAStationIcon />}
                          disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferButton')?.DISABLE_ALAN}
                          style={{ textTransform: 'none' }}
                          onClick={handleTransfer}
                        >
                          Tranfer
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
              </Grid>
        </LocalizationProvider>
    </div>
  );
};

export default Transfer;
